import { useState } from 'react';
import PortersFramework from './frameworks/PortersFramework';
import SWOTFramework from './frameworks/SWOTFramework';
import PESTELFramework from './frameworks/PESTELFramework';
import BMCFramework from './frameworks/BMCFramework';
import SEAFGESFramework from './frameworks/SEAFGESFramework';

const FRAMEWORK_TABS = [
  { id: 'porters', label: "Porter's Five Forces" },
  { id: 'swot', label: 'SWOT Analysis' },
  { id: 'pestel', label: 'PESTEL' },
  { id: 'bmc', label: 'Business Model Canvas' },
  { id: 'seaf_ges', label: 'SEAF GES' },
];

export default function FrameworksPanel({ dealId }) {
  const [activeFramework, setActiveFramework] = useState('porters');

  return (
    <div>
      <div style={{ display: 'flex', borderBottom: '1px solid var(--color-border)', marginBottom: 24, overflowX: 'auto' }}>
        {FRAMEWORK_TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveFramework(tab.id)}
            style={{
              padding: '8px 16px',
              border: 'none',
              background: 'none',
              cursor: 'pointer',
              fontSize: 13,
              fontWeight: activeFramework === tab.id ? 600 : 400,
              color: activeFramework === tab.id ? 'var(--color-accent)' : 'var(--color-text-secondary)',
              borderBottom: activeFramework === tab.id ? '2px solid var(--color-accent)' : '2px solid transparent',
              whiteSpace: 'nowrap',
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeFramework === 'porters' && <PortersFramework dealId={dealId} />}
      {activeFramework === 'swot' && <SWOTFramework dealId={dealId} />}
      {activeFramework === 'pestel' && <PESTELFramework dealId={dealId} />}
      {activeFramework === 'bmc' && <BMCFramework dealId={dealId} />}
      {activeFramework === 'seaf_ges' && <SEAFGESFramework dealId={dealId} />}
    </div>
  );
}
